import { DealPipelineInvestmentsQuery } from '@/__generated__/graphql';
import ActionDropdown from '@/components/basicComponents/actionDropdown';
import { IInvestmentWorkflowTransitionTask } from '@/components/dealCatalog-page/types';
import {
  MobileRow,
  MobileRowTitle,
  MobileRowValue,
  MobileTableRowWrap,
  MobileTableWrapper,
  NoResults
} from '@/components/table/mobileTable/mobileTable';
import { IItems, TableColumns } from '@/components/table/types';
import { NavigateOptions } from 'react-router-dom';
import styled from 'styled-components';
import { dealPipelineTableCellValue } from '../tableBody';

interface DealPipelineMobileTableProps {
  columnsList: TableColumns[];
  tableRows: DealPipelineInvestmentsQuery['Investments']['data'];
  openPage: (path: string, options?: NavigateOptions) => void;
  actionsByStatus: (row: DealPipelineInvestmentsQuery['Investments']['data'][number]) => IItems[];
  openMobileModal: (data: DealPipelineInvestmentsQuery['Investments']['data'][number], modalType: string) => void;
}

const DealPipelineMobileTable = ({ columnsList, tableRows, openPage, actionsByStatus, openMobileModal }: DealPipelineMobileTableProps) => {
  const TableRow = ({ el }: { el: DealPipelineInvestmentsQuery['Investments']['data'][number] }) => {
    const actionDropdownOptions = actionsByStatus(el);
    return (
      <CustomMobileTableRowWrap>
        <MobileRow>
          <MobileRowTitle>{columnsList[0].title}</MobileRowTitle>
          <FixedMobileRowValue isRedirect>
            <div onClick={() => openPage(`/strategyDetails/${encodeURIComponent(el.id)}?backToTitle=Manager Pipeline`)}>{el.name}</div>
            <div>
              <ActionDropdown options={actionDropdownOptions} />
            </div>
          </FixedMobileRowValue>
        </MobileRow>
        {columnsList
          .filter((column) => !column.isFixed)
          .map(
            (column, index) =>
              !column.isHidden && (
                <MobileRow key={column.keySort + index}>
                  <MobileRowTitle>{column.title}</MobileRowTitle>
                  <MobileRowValue key={column.key}>{dealPipelineTableCellValue(el, column, openMobileModal)}</MobileRowValue>
                </MobileRow>
              )
          )}
      </CustomMobileTableRowWrap>
    );
  };

  return (
    <MobileTableWrapper>
      {tableRows.length ? (
        tableRows.map((el: DealPipelineInvestmentsQuery['Investments']['data'][number]) => {
          return <TableRow key={el.id} el={el} />;
        })
      ) : (
        <NoResults>No Results</NoResults>
      )}
    </MobileTableWrapper>
  );
};

export default DealPipelineMobileTable;

const CustomMobileTableRowWrap = styled(MobileTableRowWrap)`
  margin-top: 5px;
`;

const FixedMobileRowValue = styled(MobileRowValue)`
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 5px;
`;
